import React from 'react';
import { Col, Row } from 'reactstrap';

import SupportLoginCardLeft from './SupportLoginCardLeft';
import SupportLoginCardRight from './SupportLoginCardRight';

class SupportLogin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  showIntercomChat = () => {
    window.Intercom('show');
  };

  render() {
    return (
      <div className="support-login-container pr-md-5 pl-md-5 mb-md-0">
        <div className="title mb-md-4">How can we help you?</div>
        <div className="divider" />
        <Row>
          <Col md={4} xs={12}>
            <div onClick={this.showIntercomChat}>
              <SupportLoginCardLeft mainTitle="Message Us" />
            </div>
            <a href="https://intercom.help/promotionwingman/en/">
              <div>
                <SupportLoginCardLeft mainTitle="FAQs" />
              </div>
            </a>
            <a href="https://intercom.help/promotionwingman/en/">
              <div>
                <SupportLoginCardLeft mainTitle="Help Center" />
              </div>
            </a>
          </Col>

          <Col md={8} xs={12}>
            <SupportLoginCardRight
              mainTitle="Command / Group Accounts"
              subTitle="support@promotionwingman.com"
              bodyText="Send an email to support@promotionwingman.com letting us know how many subscriptions you need. We will create a custom quote and purchase request to help you get things started."
            />

            <SupportLoginCardRight
              mainTitle="Email Us Directly"
              subTitle="support@promotionwingman.com"
            />
          </Col>
        </Row>
      </div>
    );
  }
}

export default SupportLogin;
